const style = {
    pageBg: '#000',
    navBg: '#000',
    navFg: '#fff',
    buttonBg: '#f7941e',
    buttonFg: '#fff',
    modalBg: '#5a5858',
    modalFg: '#fff',
    tableBg: '#000',
    tableFg: '#fff',
    tableDarkBorder: '#434343',
    tableLightBorder: '#acacac',
    tableRowLeftHover: '#545454',
    tableRowRightHover: '#282828',
    taskBg: '#373737',
    taskColor: '#f7941e',
    taskCompleteColor: '#3b7c1a',
}

export default style
